



































































































































































































import moment from "moment";
import semver from "semver";
import Vue, { PropType } from "vue";

import { RootState } from "@/store";
import { mapGetters, mapState } from "vuex";

// Components
import CustomProtocolSessionDetails from "./CustomProtocolSessionDetails.vue";
import ProtocolSessionDetails from "./ProtocolSessionDetails.vue";

// Model
import { ApiResponseStatusEnum } from "@/model/communication/ApiResponseStatusEnum";
import { GetInstallationNetworkMetricsCommand } from "@/model/communication/networkMetrics/GetInstallationNetworkMetricsCommand";
import { GetInstallationNetworkMetricsResData } from "@/model/communication/networkMetrics/GetInstallationNetworkMetricsResData";
import { ClientPrivileges } from "@/model/data/authentication/ClientPrivilegesEnum";
import { CashTypeEnum } from "@/model/data/enums/CashTypeEnum";
import { MetricTypeEnum } from "@/model/data/enums/MetricTypeEnum";
import { TunnelProtocolEnum } from "@/model/data/enums/TunnelProtocolEnum";
import { AgentTunnelSession } from "@/model/data/remoteLink/AgentTunnelSession";
import { InstallationRemoteLinkStatus } from "@/model/data/remoteLink/InstallationRemoteLinkStatus";
import { MODULE_COLORS } from "@/utility/Constants";
import { formatBytes } from "@/utility/Formatter";
import CServiceSessionDetails from "./CServiceSessionDetails.vue";

export default Vue.extend({
    components: { ProtocolSessionDetails, CustomProtocolSessionDetails, CServiceSessionDetails },
    data() {
        return {
            ClientPrivileges,
            tab: 0,
            TunnelProtocolEnum,
            customSessions: this.installation.customProtocolSessions,
            names: [],
            MODULE_COLORS,
            networkInSeries: [],
            networkOutSeries: [],
            dateListString: [],
            loadingChart: false,
            customSessionIndexes: [],
            customSessionIndex: 1,
        };
    },
    props: {
        installation: Object as PropType<InstallationRemoteLinkStatus>,
        loading: Boolean,
    },
    watch: {
        "installation.name": {
            handler(newVal, oldVal) {
                if (newVal && oldVal && newVal.name != oldVal.name) this.tab = 0;
                this.customSessions = this.installation.customProtocolSessions;
                this.customSessionIndexes = [];
                this.customSessionIndex = 1;
                this.names = [];
                this.customSessions.forEach((element) => {
                    this.names.push(`${this.$t("common.custom")} (${this.$t("options.port")} ${element.servicePort})`);
                    this.customSessionIndexes.push(this.customSessionIndex);
                    this.customSessionIndex += 1;
                });
                this.getAgentTunnelServiceNetworkMetrics();
            },
            immediate: true,
        },
    },
    computed: {
        ...mapState({
            userTheme: (state: RootState) => state.authMod.currentUser.userConfig.theme,
        }),
        ...mapGetters(["userDateFormat", "authUserHasPrivilege"]),
        chartNetworkInTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "line",
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                        tickAmount: 4,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 0) : null),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => (value != null ? formatBytes(value) : null),
                        },
                    },
                },
                series: this.networkInSeries,
            };
        },
        chartNetworkOutTrend() {
            return {
                options: {
                    theme: {
                        mode: this.userTheme,
                    },
                    chart: {
                        type: "line",
                        zoom: {
                            enabled: false,
                        },
                        animations: {
                            enabled: false,
                        },
                    },
                    dataLabels: {
                        enabled: false,
                    },
                    stroke: {
                        curve: "straight",
                    },
                    grid: {
                        row: {
                            colors: ["#f3f3f3", "transparent"],
                            opacity: 0.5,
                        },
                        xaxis: {
                            lines: {
                                show: false,
                            },
                        },
                    },
                    xaxis: {
                        type: "category",
                        categories: this.dateListString,
                        tickAmount: 4,
                    },
                    yaxis: {
                        labels: {
                            formatter: (value) => (value != null ? formatBytes(value, true, 0) : null),
                        },
                    },
                    tooltip: {
                        y: {
                            formatter: (value) => (value != null ? formatBytes(value) : null),
                        },
                    },
                },
                series: this.networkOutSeries,
            };
        },
        customSessionTabIndex() {
            let tabIndex = 0;
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkHttp)) tabIndex++;
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkCaosDb)) tabIndex++;
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkSsh)) tabIndex++;
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkUltraVnc)) tabIndex++;
            if (this.authUserHasPrivilege(ClientPrivileges.RemoteLinkCService)) tabIndex++;
            return tabIndex;
        },
        cserviceEnabled() {
            let enabled = false;
            for (let machine of this.installation.machines) {
                if (machine.supportedCashType != CashTypeEnum.Coin) enabled = true;
            }
            return enabled;
        },
        agentHasSupportedVersion() {
            if (this.installation && this.installation.agent && this.installation.agent.length > 0 && this.installation.agent[0].version) {
                let splittedVersion = this.installation.agent[0].version.split(".");
                return semver.gte(`${splittedVersion[0]}.${splittedVersion[1]}.${splittedVersion[2]}`, "9.0.0");
            }
            return false;
        },
        agentHasSupportedVersionForCService() {
            if (this.installation && this.installation.agent && this.installation.agent.length > 0 && this.installation.agent[0].version) {
                let splittedVersion = this.installation.agent[0].version.split(".");
                return semver.gte(`${splittedVersion[0]}.${splittedVersion[1]}.${splittedVersion[2]}`, "9.0.0");
            }
            return false;
        },
    },
    methods: {
        addCustomSession() {
            if (this.customSessions.length < 15) {
                this.customSessionIndexes.push(this.customSessionIndex);
                this.customSessionIndex += 1;
                this.customSessions.push(new AgentTunnelSession());
                this.tab = this.customSessionTabIndex + this.customSessions.length - 1;
                this.names.push(this.$t("common.custom"));
            }
        },
        removeSession(index: number) {
            this.customSessionIndexes.splice(index, 1);
            this.customSessions.splice(index, 1);
            this.names.splice(index, 1);
        },
        changeName(event, index: number) {
            this.customSessions[index] = event;
            this.names.splice(index, 1, `${this.$t("common.custom")} (${this.$t("options.port")} ${event.servicePort})`);
        },
        async getAgentTunnelServiceNetworkMetrics() {
            this.loadingChart = true;
            try {
                let response: GetInstallationNetworkMetricsResData = await new GetInstallationNetworkMetricsCommand(
                    this.installation.name,
                    moment().subtract(1, "weeks").utc().toDate(),
                    moment().utc().toDate(),
                    MetricTypeEnum.Tunnel
                ).execute();

                if (response.responseStatus == ApiResponseStatusEnum.Success) {
                    let networkIn = [];
                    let networkOut = [];
                    response.metrics.forEach((metric) => {
                        networkIn.push(metric.byteReceived);
                        networkOut.push(metric.byteSent);
                        this.dateListString.push(moment(metric.dateTime).format(this.userDateFormat));
                    });
                    this.networkInSeries = [{ name: this.$t("network_metrics.serverIn"), data: networkIn }];
                    this.networkOutSeries = [{ name: this.$t("network_metrics.serverOut"), data: networkOut }];
                }
            } catch (error) {
                console.log("Something went wrong sending GetAgentTunnelServiceConnectedTime request ", error);
            }
            this.loadingChart = false;
        },
    },
});
